import { getAllComponents } from "./CreateRulesPerPage";

const makeComponentsEditable = (editor) => {
    
    editor.on('block:drag:stop', () => {

        const all = getAllComponents(editor.DomComponents.getWrapper());

        all.forEach(comp => {
            
            comp.set('hoverable', true);
            comp.set('selectable',true);
            comp.set('editable',true);
            comp.set('droppable',true);
            comp.set('draggable',true);
            comp.set('removable',true);
            comp.set('copyable',true);
            if(editor.Commands.isActive('command-enable-drag-drop') === true){
                comp.set('resizable',true);
            }

            const classes = comp.getClasses();
            classes.filter( componentClass => componentClass === 'annotation-messages' || componentClass === 'border-annotations').map( componentClass => {
                comp.removeClass(componentClass);
                return comp;
            })

        })

        
    })
}

export default  makeComponentsEditable;